<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-post20-stratotanker-mission-02-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-post20-stratotanker-mission-02-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 0.63403961016071;"
    data-aspect-ratio="0.634"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-post20-stratotanker-mission-02-xs-img"
      class="g-post20-stratotanker-mission-02-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post20-stratotanker-mission-02-xs.jpg);"
    ></div>
    <div
      id="g-ai0-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:10.4868%;margin-top:-9.6px;left:50.2912%;margin-left:-65.5px;width:131px;"
    >
      <p class="g-pstyle1">Boom deployment</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-text g-aiAbs"
      style="top:12.6808%;left:50.3992%;margin-left:-22.8788%;width:45.7576%;"
    >
      <p class="g-pstyle2">
        The person who operates the boom lowers the refueling boom from the rear
        of the tanker.
      </p>
    </div>
    <div
      id="g-ai0-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:30.853%;margin-top:-9.6px;left:53.1919%;margin-left:-32px;width:64px;"
    >
      <p class="g-pstyle3">41.53m</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:52.3719%;margin-top:-9.6px;right:69.0699%;width:56px;"
    >
      <p class="g-pstyle4">Boom</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:53.7168%;margin-top:-9.6px;right:86.1245%;width:56px;"
    >
      <p class="g-pstyle4">Probe</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:67.1821%;margin-top:-9.7px;left:54.4493%;margin-left:-15.5px;width:31px;"
    >
      <p class="g-pstyle0">4</p>
    </div>
    <div
      id="g-ai0-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:72.3537%;margin-top:-9.6px;left:52.0682%;width:159px;"
    >
      <p class="g-pstyle5">Alignment and contact</p>
    </div>
    <div
      id="g-ai0-9"
      class="g-text g-aiAbs"
      style="top:74.5477%;left:52.0683%;width:40.303%;"
    >
      <p class="g-pstyle6">
        The operator guides the boom toward the fighter&rsquo;s receptacle with
        small control inputs. The boom locks into the aircraft.
      </p>
    </div>
    <div
      id="g-ai0-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:84.266%;margin-top:-9.6px;right:70.1752%;width:106px;"
    >
      <p class="g-pstyle4">Refueling port</p>
    </div>
    <div
      id="g-ai0-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:5.6995%;margin-top:-9.7px;left:50.2968%;margin-left:-15px;width:30px;"
    >
      <p class="g-pstyle0">3</p>
    </div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-post20-stratotanker-mission-02-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 1.47439386672562;"
    data-aspect-ratio="1.474"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-post20-stratotanker-mission-02-sm-img"
      class="g-post20-stratotanker-mission-02-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post20-stratotanker-mission-02-sm.jpg);"
    ></div>
    <div
      id="g-ai1-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:13.1773%;margin-top:-9.6px;right:75.7278%;width:131px;"
    >
      <p class="g-pstyle1">Boom deployment</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-text g-aiAbs"
      style="top:16.4785%;right:75.5674%;width:24.3137%;"
    >
      <p class="g-pstyle2">
        The person who operates the boom lowers the refueling boom from the rear
        of the tanker.
      </p>
    </div>
    <div
      id="g-ai1-4"
      class="g-text g-aiAbs g-aiPointText"
      style="top:25.3194%;margin-top:-9.6px;left:64.8485%;margin-left:-32px;width:64px;"
    >
      <p class="g-pstyle3">41.53m</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:54.5182%;margin-top:-9.6px;right:76.5116%;width:56px;"
    >
      <p class="g-pstyle4">Probe</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:57.4092%;margin-top:-9.6px;right:58.0044%;width:56px;"
    >
      <p class="g-pstyle4">Boom</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:59.7459%;margin-top:-9.7px;left:48.4316%;margin-left:-15.5px;width:31px;"
    >
      <p class="g-pstyle0">4</p>
    </div>
    <div
      id="g-ai1-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:67.5275%;margin-top:-9.6px;left:46.8909%;width:159px;"
    >
      <p class="g-pstyle5">Alignment and contact</p>
    </div>
    <div
      id="g-ai1-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:70.9967%;margin-top:-9.6px;right:81.9046%;width:106px;"
    >
      <p class="g-pstyle4">Refueling port</p>
    </div>
    <div
      id="g-ai1-10"
      class="g-text g-aiAbs"
      style="top:70.8287%;left:46.8909%;width:41.1765%;"
    >
      <p class="g-pstyle6">
        The operator guides the boom toward the fighter&rsquo;s receptacle with
        small control inputs. The boom locks into the aircraft.
      </p>
    </div>
    <div
      id="g-ai1-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:5.9739%;margin-top:-9.7px;left:21.9642%;margin-left:-15px;width:30px;"
    >
      <p class="g-pstyle0">3</p>
    </div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-post20-stratotanker-mission-02-md"
    class="g-artboard"
    style="min-width: 660px;max-width: 929px;aspect-ratio: 1.88971915190887;"
    data-aspect-ratio="1.89"
    data-min-width="660"
    data-max-width="929"
  >
    <div
      id="g-post20-stratotanker-mission-02-md-img"
      class="g-post20-stratotanker-mission-02-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post20-stratotanker-mission-02-md.jpg);"
    ></div>
    <div
      id="g-ai2-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:16.5104%;margin-top:-9.7px;right:72.4467%;width:147px;"
    >
      <p class="g-pstyle1">Boom deployment</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:18.801%;margin-top:-9.7px;left:67.5212%;margin-left:-35px;width:70px;"
    >
      <p class="g-pstyle2">41.53m</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-text g-aiAbs"
      style="top:20.0425%;right:72.5286%;width:27.1212%;"
    >
      <p class="g-pstyle3">
        The person who operates the boom lowers the refueling boom from the rear
        of the tanker.
      </p>
    </div>
    <div
      id="g-ai2-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:53.7322%;margin-top:-9.7px;right:55.3308%;width:61px;"
    >
      <p class="g-pstyle4">Boom</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:54.0185%;margin-top:-9.7px;right:72.2961%;width:61px;"
    >
      <p class="g-pstyle4">Probe</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:63.7534%;margin-top:-9.7px;right:83.0013%;width:118px;"
    >
      <p class="g-pstyle4">Refueling port</p>
    </div>
    <div
      id="g-ai2-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:64.6124%;margin-top:-9.7px;left:40.2023%;margin-left:-15.5px;width:31px;"
    >
      <p class="g-pstyle0">4</p>
    </div>
    <div
      id="g-ai2-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:72.0567%;margin-top:-9.7px;left:39.0117%;width:178px;"
    >
      <p class="g-pstyle5">Alignment and contact</p>
    </div>
    <div
      id="g-ai2-10"
      class="g-text g-aiAbs"
      style="top:75.5888%;left:39.0118%;width:43.7879%;"
    >
      <p class="g-pstyle6">
        The operator guides the boom toward the fighter&rsquo;s receptacle with
        small control inputs. The boom locks into the aircraft.
      </p>
    </div>
    <div
      id="g-ai2-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:9.6387%;margin-top:-9.7px;left:25.712%;margin-left:-15px;width:30px;"
    >
      <p class="g-pstyle0">3</p>
    </div>
  </div>
  <!-- Artboard: lg -->
  <div
    id="g-post20-stratotanker-mission-02-lg"
    class="g-artboard"
    style="min-width: 930px;aspect-ratio: 2.3570743883035;"
    data-aspect-ratio="2.357"
    data-min-width="930"
  >
    <div
      id="g-post20-stratotanker-mission-02-lg-img"
      class="g-post20-stratotanker-mission-02-lg-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post20-stratotanker-mission-02-lg.jpg);"
    ></div>
    <div
      id="g-ai3-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:26.0201%;margin-top:-9.7px;left:67.7083%;margin-left:-35px;width:70px;"
    >
      <p class="g-pstyle1">41.53m</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:28.3011%;margin-top:-9.7px;right:68.4716%;width:147px;"
    >
      <p class="g-pstyle2">Boom deployment</p>
    </div>
    <div
      id="g-ai3-4"
      class="g-text g-aiAbs"
      style="top:31.4277%;right:68.5297%;width:19.2473%;"
    >
      <p class="g-pstyle3">
        The person who operates the boom lowers the refueling boom from the rear
        of the tanker.
      </p>
    </div>
    <div
      id="g-ai3-5"
      class="g-text g-aiAbs g-aiPointText"
      style="top:65.5581%;margin-top:-9.7px;right:69.8443%;width:61px;"
    >
      <p class="g-pstyle4">Probe</p>
    </div>
    <div
      id="g-ai3-6"
      class="g-text g-aiAbs g-aiPointText"
      style="top:65.8116%;margin-top:-9.7px;right:57.5549%;width:61px;"
    >
      <p class="g-pstyle4">Boom</p>
    </div>
    <div
      id="g-ai3-7"
      class="g-text g-aiAbs g-aiPointText"
      style="top:66.3185%;margin-top:-9.7px;right:80.9236%;width:118px;"
    >
      <p class="g-pstyle4">Refueling port</p>
    </div>
    <div
      id="g-ai3-8"
      class="g-text g-aiAbs g-aiPointText"
      style="top:66.8254%;margin-top:-9.7px;left:47.9276%;margin-left:-15.5px;width:31px;"
    >
      <p class="g-pstyle0">4</p>
    </div>
    <div
      id="g-ai3-9"
      class="g-text g-aiAbs g-aiPointText"
      style="top:73.415%;margin-top:-9.7px;left:47.0827%;width:178px;"
    >
      <p class="g-pstyle5">Alignment and contact</p>
    </div>
    <div
      id="g-ai3-10"
      class="g-text g-aiAbs"
      style="top:76.5416%;left:47.0827%;width:31.0753%;"
    >
      <p class="g-pstyle6">
        The operator guides the boom toward the fighter&rsquo;s receptacle with
        small control inputs. The boom locks into the aircraft.
      </p>
    </div>
    <div
      id="g-ai3-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:22.2184%;margin-top:-9.7px;left:30.2216%;margin-left:-15px;width:30px;"
    >
      <p class="g-pstyle0">3</p>
    </div>
  </div>
</div>

<!-- End ai2svelte - 2026-03-18 12:24 -->

<!-- Generated by ai2svelte v1.0.3 - 2026-03-18 12:24 -->
<!-- ai file: post20-stratotanker-mission-02.ai -->
<style lang="scss">
  #g-post20-stratotanker-mission-02-box {
    container-type: inline-size;
    container-name: g-post20-stratotanker-mission-02-box;
  }
  #g-post20-stratotanker-mission-02-box,
  #g-post20-stratotanker-mission-02-box .g-artboard {
    margin: 0 auto;
  }
  #g-post20-stratotanker-mission-02-box p {
    margin: 0;
  }
  #g-post20-stratotanker-mission-02-box .g-aiAbs {
    position: absolute;
  }
  #g-post20-stratotanker-mission-02-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-post20-stratotanker-mission-02-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-post20-stratotanker-mission-02-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-post20-stratotanker-mission-02-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-post20-stratotanker-mission-02-box {
    width: 100%;
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-post20-stratotanker-mission-02-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-post20-stratotanker-mission-02-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-post20-stratotanker-mission-02-md {
        display: block !important;
      }
    }
    @container (min-width:930px) {
      #g-post20-stratotanker-mission-02-lg {
        display: block !important;
      }
    }
  }
  #g-post20-stratotanker-mission-02-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post20-stratotanker-mission-02-xs p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 16px;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-post20-stratotanker-mission-02-xs .g-pstyle0 {
    font-weight: 700;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
    text-align: center;
  }
  #g-post20-stratotanker-mission-02-xs .g-pstyle1 {
    font-weight: 500;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-post20-stratotanker-mission-02-xs .g-pstyle2 {
    font-weight: 300;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-post20-stratotanker-mission-02-xs .g-pstyle3 {
    font-weight: 300;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-post20-stratotanker-mission-02-xs .g-pstyle4 {
    font-weight: 400;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-post20-stratotanker-mission-02-xs .g-pstyle5 {
    font-weight: 500;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
  }
  #g-post20-stratotanker-mission-02-xs .g-pstyle6 {
    font-weight: 300;
    padding-bottom: 9px;
  }
  #g-post20-stratotanker-mission-02-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post20-stratotanker-mission-02-sm p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 16px;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-post20-stratotanker-mission-02-sm .g-pstyle0 {
    font-weight: 700;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
    text-align: center;
  }
  #g-post20-stratotanker-mission-02-sm .g-pstyle1 {
    font-weight: 500;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-post20-stratotanker-mission-02-sm .g-pstyle2 {
    font-weight: 300;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-post20-stratotanker-mission-02-sm .g-pstyle3 {
    font-weight: 300;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-post20-stratotanker-mission-02-sm .g-pstyle4 {
    font-weight: 400;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-post20-stratotanker-mission-02-sm .g-pstyle5 {
    font-weight: 500;
    line-height: 18px;
    height: 18px;
    padding-bottom: 9px;
  }
  #g-post20-stratotanker-mission-02-sm .g-pstyle6 {
    font-weight: 300;
    padding-bottom: 9px;
  }
  #g-post20-stratotanker-mission-02-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post20-stratotanker-mission-02-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 18px;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-post20-stratotanker-mission-02-md .g-pstyle0 {
    font-weight: 700;
    height: 18px;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-post20-stratotanker-mission-02-md .g-pstyle1 {
    font-weight: 500;
    height: 18px;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-post20-stratotanker-mission-02-md .g-pstyle2 {
    font-weight: 300;
    height: 18px;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-post20-stratotanker-mission-02-md .g-pstyle3 {
    font-weight: 300;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-post20-stratotanker-mission-02-md .g-pstyle4 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-post20-stratotanker-mission-02-md .g-pstyle5 {
    font-weight: 500;
    height: 18px;
    padding-bottom: 9px;
  }
  #g-post20-stratotanker-mission-02-md .g-pstyle6 {
    font-weight: 300;
    padding-bottom: 9px;
  }
  #g-post20-stratotanker-mission-02-lg {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post20-stratotanker-mission-02-lg p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 18px;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    height: auto;
    position: static;
  }
  #g-post20-stratotanker-mission-02-lg .g-pstyle0 {
    font-weight: 700;
    height: 18px;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-post20-stratotanker-mission-02-lg .g-pstyle1 {
    font-weight: 300;
    height: 18px;
    padding-bottom: 9px;
    text-align: center;
  }
  #g-post20-stratotanker-mission-02-lg .g-pstyle2 {
    font-weight: 500;
    height: 18px;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-post20-stratotanker-mission-02-lg .g-pstyle3 {
    font-weight: 300;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-post20-stratotanker-mission-02-lg .g-pstyle4 {
    font-weight: 400;
    height: 18px;
    padding-bottom: 9px;
    text-align: right;
  }
  #g-post20-stratotanker-mission-02-lg .g-pstyle5 {
    font-weight: 500;
    height: 18px;
    padding-bottom: 9px;
  }
  #g-post20-stratotanker-mission-02-lg .g-pstyle6 {
    font-weight: 300;
    padding-bottom: 9px;
  }

  /* Custom CSS */
</style>
